// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: icon("ic_user"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.dashboard,
        icon: ICONS.dashboard,
      },
      {
        title: "Deposits",
        path: PATH_DASHBOARD.deposits,
        icon: ICONS.dashboard,
      },
      {
        title: "Withdrawals",
        path: PATH_DASHBOARD.withdraw,
        icon: ICONS.dashboard,
      },
      {
        title: "My Referrals",
        path: PATH_DASHBOARD.invitations,
        icon: ICONS.dashboard,
      },
      {
        title: "Rewards",
        path: PATH_DASHBOARD.commissions,
        icon: ICONS.dashboard,
      },
      {
        title: "Wallet Address",
        path: PATH_DASHBOARD.thirdPartyAddress,
        icon: ICONS.dashboard,
      },
      {
        title: "Profile",
        path: PATH_DASHBOARD.profile,
        icon: ICONS.dashboard,
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: "management",
  //   items: [
  //     {
  //       title: "user",
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: "Four", path: PATH_DASHBOARD.user.four },
  //         { title: "Five", path: PATH_DASHBOARD.user.five },
  //         { title: "Six", path: PATH_DASHBOARD.user.six },
  //       ],
  //     },
  //   ],
  // },
];

export default navConfig;
